document.addEventListener('DOMContentLoaded', function () {
  try {
    const items = JSON.parse(localStorage.getItem('selectedProducts') || '[]');
    if (items.length === 0) return;

    const reminder = document.getElementById('express-order-reminder');
    const count = document.getElementById('express-order-reminder-count');
    const btn = document.getElementById('express-order-reminder-btn');

    if (reminder && count) {
      count.textContent = items.length;
      reminder.classList.add('express-order-reminder--visible');
    }

    if (btn) {
      btn.addEventListener('click', async function () {
        btn.disabled = true;
        btn.querySelector('span').textContent = 'Ajout en cours...';

        try {
          const cartItems = items.map((product) => ({
            id: parseInt(product.variantId),
            quantity: product.quantity,
          }));

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: cartItems }),
          });

          if (response.ok) {
            localStorage.removeItem('selectedProducts');
            reminder.classList.remove('express-order-reminder--visible');
            window.location.reload();
          } else {
            throw new Error("Erreur lors de l'ajout");
          }
        } catch (e) {
          btn.disabled = false;
          btn.querySelector('span').textContent = 'Ajouter au panier';
          alert('Une erreur est survenue : ' + e.message);
        }
      });
    }
  } catch (e) {
    console.error('Express order reminder error:', e);
  }
});